var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import ModerateRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Moderate";
import { RecognitionTypeEdit } from "@irati/recognition/enums/Moderation";
import ArchiveRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Archive";
import Actions from "../Recognition/Actions";
import UpdateRecognition from "../Recognition/UpdateRecognition";
import ModeratedMessage from "../../shared/Moderated";
import { ActionsWrapper, ConfirmRemoveRecognition, ConfirmArchiveRecognition, StyledPara } from "./styled";
var ModeratedRecognitionMessage = /** @class */ (function (_super) {
    __extends(ModeratedRecognitionMessage, _super);
    function ModeratedRecognitionMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editMode: null
        };
        _this.enableUpdateMode = function () {
            _this.setState({ editMode: RecognitionTypeEdit.UPDATE });
        };
        _this.enableModerateMode = function () {
            _this.setState({ editMode: RecognitionTypeEdit.MODERATE });
        };
        _this.enableArchiveMode = function () {
            _this.setState({ editMode: RecognitionTypeEdit.ARCHIVE });
        };
        _this.disableEditMode = function () {
            _this.setState({ editMode: null });
        };
        return _this;
    }
    ModeratedRecognitionMessage.prototype.render = function () {
        var _this = this;
        var _a = this.props, recognition = _a.recognition, onArchive = _a.onArchive;
        var editMode = this.state.editMode;
        var isUpdateMode = editMode === RecognitionTypeEdit.UPDATE;
        var isModerateMode = editMode === RecognitionTypeEdit.MODERATE;
        var isArchiving = editMode === RecognitionTypeEdit.ARCHIVE;
        return (React.createElement(Fragment, null,
            React.createElement(ActionsWrapper, null,
                React.createElement(Actions, { pullRight: true, disabled: isUpdateMode || isModerateMode, recognition: recognition, onClickEdit: this.enableUpdateMode, onClickRemove: this.enableModerateMode, onClickArchive: this.enableArchiveMode }),
                isArchiving &&
                    React.createElement(ArchiveRecognitionMutation, { recognition: recognition, onCompleted: onArchive }, function (mutate, apolloState) { return (React.createElement(ConfirmArchiveRecognition, { onCancel: _this.disableEditMode, onConfirm: mutate, apolloState: apolloState })); }),
                isModerateMode &&
                    React.createElement(ModerateRecognitionMutation, { recognition: recognition, onCompleted: this.disableEditMode }, function (mutate) { return (React.createElement(ConfirmRemoveRecognition, { onCancel: _this.disableEditMode, onConfirm: mutate })); })),
            isUpdateMode
                ? React.createElement(UpdateRecognition, { recognition: recognition, onUpdateSuccess: this.disableEditMode, onClickCancel: this.disableEditMode })
                : (React.createElement(StyledPara, { className: "text-left" },
                    React.createElement(ModeratedMessage, { message: recognition.message, isModerated: recognition.moderated })))));
    };
    return ModeratedRecognitionMessage;
}(Component));
export default ModeratedRecognitionMessage;
